import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { Box, styled } from '@mui/material';
import moment from 'moment';
import { TemplateTransportType } from '../../../../../types/communication/transport-type';

const SignatureIconSx = {
  fontSize: '16px',
  display: 'flex'
};

export const ManagedCommCardWrapper = styled(Box)({
  color: 'black',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});

export const ManagedCommCard = styled(Box)({
  color: 'rgba(44, 53, 66, 1)',
  backgroundColor: 'rgba(249, 250, 251, 1)',
  border: 'solid 1px rgba(219, 221, 213, 1)',
  borderRadius: '8px',
  padding: '10px 6px 12px 12px',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    transition: 'background-color 0.2s ease'
  }
});

export const ManagedCommSignature = styled((props: any) => (
  <Box
    sx={{
      color: 'black',
      fontSize: '12px',
      fontWeight: 500,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: '5px 0px 0 auto'
    }}
  >
    <Box sx={{ fontSize: '16px' }}>
      {props.communication.type == TemplateTransportType.Email && <MailOutlineIcon sx={{ ...SignatureIconSx }} />}
      {props.communication.type == TemplateTransportType.Sms && <SmsOutlinedIcon sx={{ ...SignatureIconSx }} />}
      {props.communication.type == TemplateTransportType.Voice && <PhoneIcon sx={{ ...SignatureIconSx }} />}
      {(props.communication.type == TemplateTransportType.Letter ||
        props.communication.type == TemplateTransportType.Postcard) && (
        <ContactMailOutlinedIcon sx={{ ...SignatureIconSx }} />
      )}
    </Box>
    <Box sx={{ paddingLeft: '5px' }}>
      RW System&nbsp;
      {props.communication.type === TemplateTransportType.Email && 'Email'}
      {props.communication.type === TemplateTransportType.Sms && 'Sms'}
      {props.communication.type === TemplateTransportType.Letter && 'Mail'}
      {props.communication.type === TemplateTransportType.Postcard && 'Mail'}
      {props.communication.type === TemplateTransportType.Voice && 'Phone'}
    </Box>
    <Box sx={{ padding: '0 5px' }}>|</Box>
    <Box>{moment(props.communication.date).format('h:mm A')}</Box>
  </Box>
))(() => ({}));
